/**
 * 组件的emit事件声明
 */
export const keyboardEmits = [
  /** 点击键盘上的内容按键触发 */
  'input',

  /** 点击删除按键时触发 */
  'delete',

  /** 点击右上角关闭按钮时触发 */
  'close',

  /** 点击非键盘区域时触发 */
  'blur',

  /** 点击确认按钮时触发 */
  'confirm',
] as const;

export const emits =  [...keyboardEmits];

/** 键盘组件的emit事件类型 */
export type KeyboardEmitsEvent =  typeof keyboardEmits[number];

